import * as React from 'react';

var _circle, _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgNear = function SvgNear(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 60,
        r: 60,
        fill: "#000"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M78.142 33.067 65.607 51.671c-.867 1.267.8 2.8 2 1.733L79.943 42.67c.333-.267.8-.067.8.4v33.54c0 .466-.6.666-.867.333l-37.34-44.675C41.336 30.8 39.602 30 37.668 30h-1.334C32.868 30 30 32.867 30 36.401V83.61a6.403 6.403 0 0 0 6.401 6.401c2.2 0 4.268-1.133 5.468-3.067L54.404 68.34c.867-1.267-.8-2.8-2-1.733L40.068 77.275c-.333.267-.8.067-.8-.4V43.403c0-.467.6-.667.867-.334l37.34 44.675c1.2 1.467 3.001 2.267 4.868 2.267h1.334a6.403 6.403 0 0 0 6.4-6.401V36.4a6.403 6.403 0 0 0-6.4-6.401 6.46 6.46 0 0 0-5.535 3.067"
    })));
};

export { SvgNear as ReactComponent };
//# sourceMappingURL=NEAR.svg.es.js.map
